<template>
  <button
    class="material-delete-button d-flex justify-center items-center"
    @click="clickDeleteDialog"
  >
    <v-ons-icon icon="fa-close" />
  </button>
</template>

<script setup>
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import axios from '@/composable/axios';
import { handleAxiosCommonException } from '@/composable/common';
import { onsConfirm } from '@/composable/onsen_common';

const props = defineProps({
  material: {
    type: Object,
    default: () => ({}),
  },
  getMaterial: {
    type: Function,
    default: () => {},
  },
});

// Vuexストアのインスタンスを取得
const store = useStore();
const { t } = useI18n();

/**
 * 素材削除処理
 */
const materialDelete = () => {
  // 素材削除処理を実行
  const DeleteMaterialParameters = new URLSearchParams();
  DeleteMaterialParameters.append('materialId', props.material.materialId);
  DeleteMaterialParameters.append('userId', store.getters['userInformation/getUserId']);

  axios
    .delete('/material', {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      data: DeleteMaterialParameters,
    })
    .then(() => {})
    .catch((error) => {
      // Axios共通エラーハンドリング処理をCall
      handleAxiosCommonException(error);
    })
    .finally(() => {
      props.getMaterial();
    });
};

/**
 * 素材削除確認ダイアログ表示処理
 */
const clickDeleteDialog = () => {
  // 素材削除処理可否メッセージ出力
  onsConfirm(t('message.SIGNAGE002I')).then(() => {
    // 確認メッセージにて「OK」押下時に素材削除処理を実行
    materialDelete();
  });
};
</script>

<style scoped>
.material-delete-button {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  height: 2.2rem;
  width: 2.2rem;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  z-index: 1;
}
</style>
